import { useRef } from 'react';

import { TooltipHover } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import type { Phone } from 'src/models/resumeCard';

import ChatikDeepLink from 'src/components/ResumeCard/Body/Contacts/DeepLinks/Chatik';
import MessengerDeepLinks from 'src/components/ResumeCard/Body/Contacts/DeepLinks/Messengers';

interface Props {
    phone: Phone;
    resumeId: string;
    resumeHash: string;
    simHash?: string;
    created: number;
    visited: boolean;
    markAsRead?: () => void;
    topicId?: string;
    isResponse: boolean;
    onContactsClick?: () => void;
}

const TrlKeys = {
    contactsTooltip: 'employer.hiringManager.contactsTooltip',
};

const DeepLinks: TranslatedComponent<Props> = ({
    phone,
    resumeId,
    resumeHash,
    simHash,
    created,
    markAsRead,
    isResponse,
    topicId,
    onContactsClick,
    trls,
}) => {
    const activatorRef = useRef<HTMLSpanElement>(null);
    const isHiringManager = useSelector((state) => state.isHiringManager);
    return (
        <>
            <span data-qa="resume-card-deep-links" ref={activatorRef}>
                <MessengerDeepLinks
                    phone={phone.raw}
                    resumeId={resumeId}
                    resumeHash={resumeHash}
                    simHash={simHash}
                    created={created}
                    markAsRead={markAsRead}
                />
                {isResponse && topicId && (
                    <ChatikDeepLink topicId={topicId} markAsRead={markAsRead} onContactsClick={onContactsClick} />
                )}
            </span>
            {isHiringManager && (
                <TooltipHover activatorRef={activatorRef} placement="top-center">
                    {trls[TrlKeys.contactsTooltip]}
                </TooltipHover>
            )}
        </>
    );
};

export default translation(DeepLinks);
